var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-3",attrs:{"color":"blue","outlined":""},on:{"click":_vm.restore}},[_vm._v(" Restore default view ")])}
var staticRenderFns = []

export { render, staticRenderFns }